var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},_vm._l((_vm.schedule),function(item){return _c('span',{staticClass:"badge badge-pill badge-info small px-2 py-2 d-inline-block mr-1 mb-1"},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }